
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"66","height":"65","viewBox":"0 0 66 65","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M43.727 32.502l20.109-20.109a5.685 5.685 0 000-8.042l-2.681-2.68a5.684 5.684 0 00-8.043 0L33.004 21.779 12.895 1.666a5.685 5.685 0 00-8.042 0L2.168 4.347a5.686 5.686 0 000 8.043L22.28 32.502 2.172 52.61a5.684 5.684 0 000 8.043l2.681 2.68a5.685 5.685 0 008.042 0l20.109-20.108 20.108 20.109a5.686 5.686 0 008.043 0l2.68-2.681a5.686 5.686 0 000-8.043L43.728 32.502z"}})])
          )
        }
      }
    